import type { QueryClient } from '@tanstack/svelte-query';
import type { GetEditionsGalleryQuery } from '#lib/websites/editions/queries/__generated__/getEditionsGallery.generated.js';
import { prepareEditionsGalleryBrowse } from '#lib/websites/editions/utils/editionsGalleryBrowse/index.js';
import type { EditionsGalleryPageLoadEvent } from '$routes/editions/gallery/types';

export {
	EDITIONS_GALLERY_BASE_FILTER,
	EDITIONS_GALLERY_BASE_VARIABLES,
	EDITIONS_GALLERY_LIMIT,
	EDITIONS_GALLERY_STALE_TIME,
} from '#lib/websites/editions/utils/editionsGalleryBrowse/index.js';

export const editionsGalleryPageLoadGql = async ({
	parent,
	data,
	url,
}: EditionsGalleryPageLoadEvent) => {
	const parentData = await parent();
	const queryClient: QueryClient = parentData.queryClient;

	const variables = prepareEditionsGalleryBrowse({
		queryClient,
		filterSections: data.filterSections,
		// The route's PageData is a union of the two server loads while the
		// flag is in place; this branch only ever runs behind the GraphQL one.
		editions: data.editions as GetEditionsGalleryQuery,
		searchParams: url.searchParams,
	});

	return {
		...parentData,
		...data,
		variables,
	};
};
